import React from "react";
import { FlexContainer } from "src/components";
import { Card, Number, TextLabel } from "./style";

export default function HeaderCard(props) {
    const { title, subtitle, quantity, width } = props;
    return (
        <Card width={width} padding="13px 21px 13px 21px">
            <FlexContainer direction="row" tDirection="row" justifyContent="space-between" alignItems="center">
                <FlexContainer direction="column" justifyContent="center" marginBottom="0px">
                    <TextLabel
                        fontSize="20px"
                        family="Manrope"
                        fontWeight="bold"
                        color="#612684"
                        marginBottom="0px"
                        style={{ textTransform: "capitalize" }}
                    >
                        {title}
                    </TextLabel>
                    <TextLabel
                        fontSize="14px"
                        family="Manrope"
                        weight="medium"
                        color="#000000"
                        marginBottom="0px"
                    >
                        {subtitle}
                    </TextLabel>
                </FlexContainer>
                <FlexContainer
                    direction="row"
                    tDirection="row"
                    mDirection="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Number style={{ textAlign: "left", fontSize: 30 }}>{quantity || 0}</Number>
                </FlexContainer>
            </FlexContainer>
        </Card>
    );
}
